import { NavigationLink, NavigationSection } from '@oresundsbron/api';

export const isNavigationLink = (x: unknown): x is NavigationLink =>
  !!x && !!(x as NavigationLink)?.pageLink;

export const isNavigationSection = (x: unknown): x is NavigationSection =>
  !!x && Array.isArray((x as NavigationSection)?.links);
